import Link from "@components/Link";
import type { NavigationLink } from "@server/gql/graphql";

import { cn } from "@/lib/utils";
import { Button } from "@ui/button";

export default function NavigationLink({
  title,
  internalLink,
  display,
  variant,
  externalLink,
  openInNewTab,
  locale,
  className,
}: NavigationLink & {
  locale?: string;
  className?: string;
}) {
  const slug = internalLink?.slug ?? externalLink ?? undefined;

  if (display === "Button") {
    return (
      <p className="prose-article-centered">
        <Button
          asChild
          variant={variant === "Outline" ? "outline" : "default"}
          className={cn("min-w-[min(100%,237px)]", className)}
        >
          <Link locale={locale} href={slug}>
            {title}
          </Link>
        </Button>
      </p>
    );
  }

  return (
    <p>
      <Link
        className="underline hover:no-underline"
        locale={locale}
        href={slug}
        target={openInNewTab ? "_blank" : undefined}
      >
        {title}
      </Link>
    </p>
  );
}
